import { useMessageGetter, useLocales } from '@messageformat/react';
import { DEFAULT_LOCALE } from '../../constants/common';
import { IO_ADD_INSURANCE_TARGET } from '../../constants/actionTypes';
import { menuCategory, defaultOption } from '../../constants/insuranceDetails';
import { useInsuranceOffer } from '../../hooks';

const DirectLink = () => {
  const [locale] = useLocales();
  const getMessage = useMessageGetter();
  const getDefaultMessage = useMessageGetter([], { locale: DEFAULT_LOCALE });
  const { state, createOrDeleteInsurance, setShowInsurancesTrue } = useInsuranceOffer();
  const { tiles } = state;

  const makeInsuranceDetail = (insuranceType, menuType) => {
    const makeQuestion = (insuranceId) => {
      const filterOption = (record) => {
        if (insuranceId === 'forest' && locale === 'sv') {
          return (
            menuType === replaceSpecialCharacters(getMessage(record?.text))
          );
        }
        return (
          menuType ===
            replaceSpecialCharacters(getDefaultMessage(record?.text)) ||
          menuType === replaceSpecialCharacters(getMessage(record?.text))
        );
      };

      if (menuType) {
        const { title, optionList } = menuCategory[insuranceId];
        const { text, value } =
          optionList.filter(filterOption).shift() || defaultOption;

        return {
          [`${insuranceId}Type`]: {
            value,
            question: getMessage(title),
            answer: getMessage(text),
            defaultQuestion: getDefaultMessage(title),
            defaultAnswer: getDefaultMessage(text),
          },
        };
      }
      return {};
    };

    const makeMenu = (accumulator, record) => {
      const { insuranceId, component, validator, icon } = record;
      const title = `uiText.${insuranceId}`;

      accumulator[replaceSpecialCharacters(getDefaultMessage(title))] = {
        icon,
        component,
        validator,
        insuranceId,
        insuranceSelectionIndex: 1,
        caption: getMessage(title),
        questions: makeQuestion(insuranceId),
        defaultCaption: getDefaultMessage(title),
      };

      return accumulator;
    };

    return tiles.reduce(makeMenu, {})[insuranceType];
  };

  const makeInitialData = (insuranceDetail, doScroll) => {
    createOrDeleteInsurance({
      type: IO_ADD_INSURANCE_TARGET,
      ...insuranceDetail,
      sendInsurance: true
    });

    setTimeout(function () {
      if (doScroll) {
        document.getElementById('firstJatka').click();
      } else {
        document
          .getElementById('insurance-title-main')
          .scrollIntoView({ behavior: 'smooth' });
      }
    }, 500);
  };

  const replaceUnderscore = (products) => {
    return products.replaceAll('_', ' ');
  };

  const replaceSpecialCharacters = (products) => {
    let chars = { ö: 'o', Ö: 'o', ä: 'a', å: 'a', Ä: 'a', Å: 'a' };
    products = products.replace(/[öÖäåÄÅ]/g, (m) => chars[m]);
    products = products.replace(/,\s*$/, '');
    products = products.toLowerCase();
    return products.replaceAll('_', ' ');
  };

  const executeSingleLink = (insuranceName, doScroll) => {
    const [insuranceType = '', menuValue = ''] = insuranceName.split(':');

    const insuranceDetail = makeInsuranceDetail(
      replaceUnderscore(insuranceType),
      replaceSpecialCharacters(menuValue)
    );

    if (insuranceDetail) makeInitialData(insuranceDetail, doScroll);
  };

  const executeMultipleLink = (paramName) => {
    const insuranceList = paramName.split(',');

    insuranceList.forEach((insuranceName) => {
      executeSingleLink(insuranceName);
    });
    // After pre-selecting multiple insurances, show the insurance questions
    setShowInsurancesTrue();

    // After showing insurances, wait 1s and smooth scroll header panel into view
    setTimeout(() => {
      if (typeof document !== 'undefined') {
        const el = document.getElementById('insurances-header-panel');
        if (el && typeof el.scrollIntoView === 'function') {
          el.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest' });
        }
      }
    }, 1000);
  };

  const directLink = () => {
    const defaultValue = '';
    const doScroll = true;
    const params = new URLSearchParams(window.location.search);

    const singleInsurance =
      params.get(getDefaultMessage('url.direct')) || defaultValue;

    if (singleInsurance) return executeSingleLink(singleInsurance, doScroll);

    const multiInsurance =
      params.get(getDefaultMessage('url.preSelect')) || defaultValue;

    if (multiInsurance) return executeMultipleLink(multiInsurance);
  };

  return { directLink };
};

export default DirectLink;
